import addError from '../../../utils/error.jsx';

export function request(id, data) {
    return {
        type: 'EVENTS_UPDATE_REQUEST',
        data,
        id
    };
}

export function error(id, errors) {
    addError(errors);

    return {
        type: 'EVENTS_UPDATE_ERROR',
        id,
        errors
    };
}

export function finish(id, event) {
    return {
        type: 'EVENTS_UPDATE_FINISH',
        event,
        id
    };
}

export function update(id, data) {
    return {
        type: 'EVENT_DATA',
        data,
        id
    };
}

export function bulk(data) {
    data.forEach(x => {
        x.id = parseInt(x.id, 10);
    });

    return {
        type: 'EVENTS_DATA',
        data
    };
}
